/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Split_PushInputs */

const en_us2_profile_editors_split_push = /** @type {(inputs: Profile_Editors_Split_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push`)
};

const pt_br2_profile_editors_split_push = /** @type {(inputs: Profile_Editors_Split_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empurrar`)
};

const es_419_profile_editors_split_push = /** @type {(inputs: Profile_Editors_Split_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empuje`)
};

const pt_pt2_profile_editors_split_push = /** @type {(inputs: Profile_Editors_Split_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empurrar`)
};

const fr_fr2_profile_editors_split_push = /** @type {(inputs: Profile_Editors_Split_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poussée`)
};

const de_de2_profile_editors_split_push = /** @type {(inputs: Profile_Editors_Split_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drücken`)
};

const it_it2_profile_editors_split_push = /** @type {(inputs: Profile_Editors_Split_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spinta`)
};

/**
* | output |
* | --- |
* | "Push" |
*
* @param {Profile_Editors_Split_PushInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_split_push = /** @type {((inputs?: Profile_Editors_Split_PushInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Split_PushInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_split_push(inputs)
	if (locale === "es-419") return es_419_profile_editors_split_push(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_split_push(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_split_push(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_split_push(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_split_push(inputs)
	return en_us2_profile_editors_split_push(inputs)
});
export { profile_editors_split_push as "profile-editors.split_push" }